export enum ErrorMessageTypeEnum {
    Error,
    Warning
}
